import React from "react";
import Banner from "./Banner/Banner";
import { nominationFormData } from "./PoliciesAndTermsData";
import MembershipPolicies from "./MembershipPolicies";
import styles from "./PoliciesAndTerms.module.css";
import RefundPolicy from "./RefundPolicy";
import PrivacyPolicies from "./PrivacyPolicies";

const PoliciesAndTerms = () => {
  return (
    <main className={styles.policiesPage}>
      <Banner />

      <section
        className={`${styles.termsBlockContainer} ${styles.nominationApplication}`}
      >
        <div className={styles.container}>
          <h3>
            Members Terms <span>& Conditions</span>
          </h3>
          <h5>
           Comprehensive governance policies ensuring transparency, security, and ethical academic standards.
          </h5>

          <div className={styles.cards}>
            {nominationFormData.map((m, idx) => (
              <div key={idx} className={styles.cardColor}>
                <div className={styles.card}>
                  <div className={styles.heading}>
                    <figure>
                      <img src={m.img} alt={m.name} />
                    </figure>
                    <h4>{m.heading}</h4>
                  </div>
                  {m.featureList.map((item) => (
                    <div className={styles.blueArrow} key={item.id}>
                      <h6>{item.title}</h6>
                      <p>{item.desc}</p>
                    </div>
                  ))}

                  <button className={styles.cardBtn}> View Full Terms</button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Membership Policies */}
      <MembershipPolicies />
      {/* Privacy & Security Policies */}
      <PrivacyPolicies />

      {/* Refund & Cancellation Policy */}
      <RefundPolicy />
    </main>
  );
};

export default PoliciesAndTerms;
